export const experienceData = [
  {
    id: 1,
    company: "Commercial Bank of Ethiopia(CBE)",
    jobtitle: "React Developer",
    startYear: "2018",
    endYear: "2019",
  },
  // {
  //   id: 2,
  //   company: "Wazema Digital Solutions",
  //   jobtitle: "Software Developer",
  //   startYear: "2019",
  //   endYear: "2022",
  // },
  // {
  //   id: 3,
  //   company: "MGM",
  //   jobtitle: "Software Developer",
  //   startYear: "2022",
  //   endYear: "2023",
  // },
  {
    id: 4,
    company: "AAK Tele-Science",
    jobtitle: "Software Developer",
    startYear: "2023",
    endYear: "Present",
  },
];
